import { FAQ } from '@shared/types';
import { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import ReactHTML from '../../../components/ReactHTML';
import CircleMinusRegularIcon from '../../../components/Icons/CircleMinusRegularIcon';
import CirclePlusRegularIcon from '../../../components/Icons/CirclePlusRegularIcon';
import { PublicCourse } from '@cademy-package/sdk-component-types';

export type FAQSectionProps = {
    course: PublicCourse;
    faqs: Array<FAQ>;
};

const Faq: FunctionComponent<{ faq: FAQ }> = ({ faq }) => {
    return (
        <li key={faq._id}>
            <details>
                <summary>
                    <CirclePlusRegularIcon className={styles.faqIconPlus} />
                    <CircleMinusRegularIcon className={styles.faqIconMinus} />
                    {faq.question}
                </summary>
                <ReactHTML html={faq.answer} />
            </details>
        </li>
    );
};

export const FAQSection: FunctionComponent<FAQSectionProps> = ({ course, faqs }) => {
    if (!course.faqs || course.faqs.length === 0) {
        return null;
    }
    return (
        <section className={styles.faq_section} aria-labelledby="faq-header">
            <h2 id="faq-header">Frequently Asked Questions</h2>
            <ul tabIndex={0}>
                {course.faqs.map((faqId) => {
                    const faq = faqs.find((faq) => faq._id === faqId);
                    if (!faq) return null;
                    return <Faq faq={faq} key={faq._id} />;
                })}
            </ul>
        </section>
    );
};

export default FAQSection;
